import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import "./project.css";
import Aos from "aos";
import "aos/dist/aos.css";
import movpc from "../imgz/mindmovie pc.png"
import movphone from "../imgz/mindmovie phone.jpg"
import img from "../imgz/Dl2Ixn.jpg";
import bitcoin from "../imgz/bitcoin pc done.png"
import amazon from "../imgz/amazon pc done.png"
import teck from "../imgz/zabinji2 pc done.png"
import next from "../imgz/mindzbook phone done.png"
import Modal  from '@material-ui/core/Modal';
import { mergeClasses } from '@material-ui/styles';
import { makeStyles } from "@material-ui/styles"
import { Paper } from "@material-ui/core"
import netflix from "../imgz/netflix.png";
import dalali from "../imgz/2023-07-04.png"

function getModalStyle() {

 
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}% )`
  }
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    top: "25vh",
    left: "20%",
    width: "80%",
    height: "50vh",
    border: '2px solid blue',
    
  },

  testing: {
    position: 'absolute',
    top: "25vh",
    left: "20%",
    width: "80%",
    height: "50vh",
    border: '2px solid white',
    boxShadow: "0 0 10px #777777",
  },

  testing3: {
    position: 'absolute',
    top: "25vh",
    left: "20%",
    width: "80%",
    height: "50vh",
    border: '2px solid white',
    boxShadow: "0 0 10px #777777",
  },

  testing4: {
    position: 'absolute',
    top: "25vh",
    left: "20%",
    width: "80%",
    height: "50vh",
    border: '2px solid white',
    boxShadow: "0 0 10px #777777",
  },

  testing5: {
    position: 'absolute',
    top: "25vh",
    left: "20%",
    width: "80%",
    height: "50vh",
    border: '2px solid white',
    boxShadow: "0 0 10px #777777",
  },

  testing6: {
    position: 'absolute',
    top: "25vh",
    left: "20%",
    width: "80%",
    height: "50vh",
    border: '2px solid white',
    boxShadow: "0 0 10px #777777",
  },
  testing7: {
    position: 'absolute',
    top: "25vh",
    left: "20%",
    width: "80%",
    height: "50vh",
    border: '2px solid white',
    boxShadow: "0 0 10px #777777",
  }
}))


function Projects() {

  useEffect(() => {
    Aos.init({duration: 2000});
}, [])
 

  const classes = useStyles();
  const [ modalStyle ] = useState(getModalStyle);
  const [open, setOpen] = useState(false)
  const [open2, setOpen2] = useState(false)
  const [open3, setOpen3] = useState(false)
  const [open4, setOpen4] = useState(false)
  const [open5, setOpen5] = useState(false)
  const [open6, setOpen6] = useState(false)
  const [open7, setOpen7] = useState(false)

    return (
        <div id="projects" className="project">

<Modal
  open={open}
  onClose={() => setOpen(false)}
  >
  <div style={modalStyle} className={classes.paper}>
  <div className="coin">
  <img src={amazon} alt="" />
  <button><Link to="/amazon" style={{textDecoration: "none"}} >Check demo</Link></button>
  </div>
  </div>
  </Modal>

  <Modal
  open={open2}
  onClose={() => setOpen2(false)}
  >
  <div style={modalStyle} className={classes.testing}>
  <div className="coin">
  <img src={bitcoin} alt="" />
  <button><Link to="/bitcoin" style={{textDecoration: "none"}} >Check demo</Link></button>
  </div>
  </div>
  </Modal>

  <Modal
  open={open3}
  onClose={() => setOpen3(false)}
  >
  <div style={modalStyle} className={classes.testing3}>
  <div className="coin">
  <img src={teck} alt="" />
  <button  ><Link to="/architect" style={{textDecoration: "none"}} >Check demo</Link></button>
  </div>
  </div>
  </Modal>

  <Modal
  open={open4}
  onClose={() => setOpen4(false)}
  >
  <div style={modalStyle} className={classes.testing4}>
  <div className="coin">
  <img src={next} alt="" />
  <button  ><Link to="/mindzbook" style={{textDecoration: "none"}} >Check demo</Link></button>
  </div>
  </div>
  </Modal>

  <Modal
  open={open5}
  onClose={() => setOpen5(false)}
  >
  <div style={modalStyle} className={classes.testing5}>
  <div className="coin">
  <img src={netflix} alt="" />
  <button><Link to="/netflix" style={{textDecoration: "none"}} >Check demo</Link></button>
  </div>
  </div>
  </Modal>

  <Modal
  open={open6}
  onClose={() => setOpen5(false)}
  >
  <div style={modalStyle} className={classes.testing6}>
  <div className="coin">
  <img src={movphone} alt="" />
  <button><Link to="/mindzmovies" style={{textDecoration: "none"}} >Check demo</Link></button>
  </div>
  </div>
  </Modal>

  <Modal
  open={open7}
  onClose={() => setOpen7(false)}
  >
  <div style={modalStyle} className={classes.testing7}>
  <div className="coin">
  <img src={dalali} alt="" />
  <button><Link to="/mindzmovies" style={{textDecoration: "none"}} >Check demo</Link></button>
  </div>
  </div>
  </Modal>


          <h1 data-aos="fade-down" >PROJECTS</h1>
              <div className="pairtotal">
              
              <div data-aos="flip-left" className="box">
                <img src={bitcoin} alt="" />
                <div className="dark">
                    <h2>BITCOIN WEBSITE</h2>
                    <button onClick={() => setOpen2(true)} >Check it out</button>
                </div>
              </div>                

              <div data-aos="flip-left" className="box">
                <img src={amazon} alt="" />
                <div className="dark">
                    <h2>Amazon Clone</h2>
                    <button onClick={() => setOpen3(true)} >Check it out</button>
                </div>
              </div>
                            
              <div data-aos="flip-right" className="box">
                <img src={teck} alt="" />
                <div className="dark">
                    <h2>Architecture site</h2>
                    <button onClick={() => setOpen3(true)} >Check it out</button>
                </div>
              </div>

              <div data-aos="flip-left" className="box">
                <img src={next} alt="" />
                <div className="dark">
                    <h2>Blog</h2>
                    <button onClick={() => setOpen4(true)} >Check it out</button>
                </div>
              </div>

              <div data-aos="flip-right" className="box">
                <img src={netflix} alt="" />
                <div className="dark">
                    <h2>Netflix Clone</h2>
                    <button onClick={() => setOpen5(true)} >Check it out</button>
                </div>
              </div>

              <div data-aos="flip-right" className="box">
                <img src={movpc} alt="" />
                <div className="dark">
                    <h2>mindz movies </h2>
                    <button onClick={() => setOpen6(true)} >Check it out</button>
                </div>
              </div>


              <div data-aos="flip-right" className="box box2">
                <img src={dalali} alt="" />
                <div className="dark dark2">
                    <h2>Zero Dalali </h2>
                    <button onClick={() => setOpen7(true)} >Check it out</button>
                </div>
              </div>

              
              
          </div>

         
        </div>

    )
}

export default Projects
